import dynamic from 'next/dynamic';

const ReferredPage = dynamic(() => import('../../js/pages/ReferredLandingPage'), {ssr: false});

export default ReferredPage;
